






import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		category: {
			type: String,
			required: true,
		},
	},
});
